import React from "react"
import { Common } from "lib/types"
import { ReactComponent as OrderIcon } from "images/icons/cart-shopping.svg"
import { PermissionGroups } from "../constants"

import { Orders } from "views/Orders/Orders"
import { ShowOrders } from "views/Orders/OrderViews/ShowOrders"
import { ViewOrder } from "views/Orders/OrderViews/ViewOrder"
import { CreateOrder } from "views/Orders/CreateOrder/CreateOrder"
import { CloneOrder } from "views/Orders/CreateOrder/CloneOrder"
import ManageOrder from "views/Orders/ManageOrder/ManageOrder"
import CustomReasonCodes from "views/Settings/CustomReason/CustomReasonCodes"
import CustomStates from "views/Settings/CustomStates/CustomStates"

export const orderRoutes: Common.Views = [
  {
    element: <Orders />,
    path: "/orders",
    title: "Orders",
    icon: OrderIcon,
    sortOrder: 4,
    requiredGroups: PermissionGroups.orders.read,
    children: [
      {
        element: <ShowOrders />,
        path: "/orders/",
        title: "Orders",
        parentPath: "/orders",
        section: "Order"
      },
      {
        element: <ViewOrder />,
        path: "/orders/:id",
        title: "Order",
        parentPath: "/orders"
      },
      {
        element: <CreateOrder />,
        path: "/orders/create-order",
        title: "Create order",
        parentPath: "/orders",
        section: "Create order",
        requiredGroups: PermissionGroups.orders.write
      },
      {
        element: <CloneOrder />,
        path: "/orders/create-order-from-existing-order/:id?",
        title: "Create order",
        parentPath: "/orders",
        requiredGroups: PermissionGroups.orders.write
      },
      {
        element: <ManageOrder />,
        path: "/orders/manage-order/:id?",
        title: "Manage order",
        parentPath: "/orders",
        requiredGroups: PermissionGroups.orders.write
      }
    ]
  },
  {
    element: <CustomReasonCodes />,
    path: "/settings/order-definitions",
    parentPath: "/settings",
    title: "Order definitions",
    section: "Order settings"
  },
  {
    element: <CustomStates />,
    path: "/settings/custom-states",
    parentPath: "/settings",
    title: "Custom states"
  }
]
